import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import { TextLH } from 'styles/components/typography'

import './Option.scss'

const Option = props => {
  const {
    innerProps: { innerRef, ...restProps },
    children,
    isSelected,
    selectProps,
    preValue,
  } = props
  const passProps = { ...restProps }

  const optionClassName = classNames('select-option', {
    'select-option--large': selectProps.menuHeight === 'large',
    'select-option--normal': selectProps.menuHeight !== 'large',
    'select-option--is-selected': isSelected,
    'select-option--select-rounded': selectProps.isRounded,
  })

  let arrow = null

  if (isSelected) {
    arrow = (
      <div className="select-option__check mr-1">
        <Icon id="btn_check" color="black" strokeWidth={'2'} />
      </div>
    )
  }

  return (
    <div {...passProps} ref={innerRef} className={optionClassName}>
      {preValue}
      <TextLH
        className="select-option__value"
        dangerouslySetInnerHTML={{ __html: children }}
      />
      {arrow}
    </div>
  )
}

Option.propTypes = {
  innerProps: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  children: PropTypes.node,
  preValue: PropTypes.node,
  selectProps: PropTypes.object,
}

Option.defaultProps = {
  preValue: null,
}

export default Option
